
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Guide to using Link events and callbacks with Identity Verification'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Link callbacks' subtitle='Guide to using Link callbacks in your integration' mdxType="Header" />
    <p>{`After integrating Identity Verification using Link, you can use Link's client-side callbacks to see how your users are progressing through the flow. Note that you will not be able to access these if you use the Plaid-hosted flow with shareable links. `}</p>
    <p><a parentName="p" {...{
        "href": "/docs/link/web/#link-web-create-onSuccess"
      }}><inlineCode parentName="a">{`onSuccess`}</inlineCode></a>{` will fire when a user has successfully completed the Link flow. The `}<inlineCode parentName="p">{`link_session_id`}</inlineCode>{` returned by `}<inlineCode parentName="p">{`onSuccess`}</inlineCode>{` can be passed to `}<inlineCode parentName="p">{`/identity_verification/get`}</inlineCode>{` in the `}<inlineCode parentName="p">{`identity_verification_id`}</inlineCode>{` field to retrieve data on the verification. Note that receiving `}<inlineCode parentName="p">{`onSuccess`}</inlineCode>{` simply means that the user completed the Identity Verification flow, not that their identity was verified. A completed session in which a user fails Identity Verification will still result in `}<inlineCode parentName="p">{`onSuccess`}</inlineCode>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "/docs/link/web/#link-web-create-onExit"
      }}><inlineCode parentName="a">{`onExit`}</inlineCode></a>{` will fire when a user exits a session without finishing all required steps. If you receive this event, you may want to provide an option for the user to restart the Link flow, and/or provide guidance on manually performing KYC.`}</p>
    <p><a parentName="p" {...{
        "href": "/docs/link/web/#link-web-create-onEvent"
      }}><inlineCode parentName="a">{`onEvent`}</inlineCode></a>{` will fire at certain points throughout the IDV flow with updates on the user's progress at each point. For each step, Plaid will send an `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-eventName-IDENTITY-VERIFICATION-START-STEP"
      }}><inlineCode parentName="a">{`IDENTITY_VERIFICATION_START_STEP`}</inlineCode></a>{` event as well as a `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-eventName-IDENTITY-VERIFICATION-PASS-STEP"
      }}><inlineCode parentName="a">{`IDENTITY_VERIFICATION_PASS_STEP`}</inlineCode></a>{` or `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-eventName-IDENTITY-VERIFICATION-FAIL-STEP"
      }}><inlineCode parentName="a">{`IDENTITY_VERIFICATION_FAIL_STEP`}</inlineCode></a>{` event based on the outcome of the step. Each step will also have an associated `}<inlineCode parentName="p">{`view_name`}</inlineCode>{`. The possible view names include:
`}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-metadata-view-name-ACCEPT-TOS"
      }}><inlineCode parentName="a">{`ACCEPT_TOS`}</inlineCode></a>{`, `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-metadata-view-name-VERIFY-SMS"
      }}><inlineCode parentName="a">{`VERIFY_SMS`}</inlineCode></a>{`,`}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-metadata-view-name-KYC-CHECK"
      }}><inlineCode parentName="a">{`KYC_CHECK`}</inlineCode></a>{`, `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-metadata-view-name-DOCUMENTARY-VERIFICATION"
      }}><inlineCode parentName="a">{`DOCUMENTARY_VERIFICATION`}</inlineCode></a>{`, `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-metadata-view-name-RISK-CHECK"
      }}><inlineCode parentName="a">{`RISK_CHECK`}</inlineCode></a>{`, `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-metadata-view-name-SCREENING"
      }}><inlineCode parentName="a">{`SCREENING`}</inlineCode></a>{`, and `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-metadata-view-name-SELFIE-CHECK"
      }}><inlineCode parentName="a">{`SELFIE_CHECK`}</inlineCode></a>{`.`}</p>
    <p>{`For each session, Plaid will also inform you of the outcome of the session by sending an `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-eventName-IDENTITY-VERIFICATION-PASS-SESSION"
      }}><inlineCode parentName="a">{`IDENTITY_VERIFICATION_PASS_SESSION`}</inlineCode></a>{` or `}<a parentName="p" {...{
        "href": "/docs/link/web/#link-web-onevent-eventName-IDENTITY-VERIFICATION-FAIL-SESSION"
      }}><inlineCode parentName="a">{`IDENTITY_VERIFICATION_FAIL_SESSION`}</inlineCode></a>{` event based on the outcome of the session.`}</p>
    <p>{`Note that, aside from `}<inlineCode parentName="p">{`IDENTITY_VERIFICATION_PASS_SESSION`}</inlineCode>{` and `}<inlineCode parentName="p">{`IDENTITY_VERIFICATION_FAIL_SESSION`}</inlineCode>{`, the sequence of view names and `}<inlineCode parentName="p">{`onEvent`}</inlineCode>{` events are subject to change without notice, as Plaid adds additional functionality and makes improvements to flows. You should treat view names as informational and not rely on them for critical business logic.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
